import React from 'react';
import { AuthProvider } from './contexts/AuthContext';
import { BrandingProvider } from './contexts/BrandingContext';
import Routes from './Routes';

function App() {
  return (
    <AuthProvider>
      <BrandingProvider>
        <Routes />
      </BrandingProvider>
    </AuthProvider>
  );
}

export default App;